(function() {
	'use strict';

	angular
		.module('iqxCore')
		.controller('JobSearchResultsCtrl', JobSearchResultsCtrl)


	function JobSearchResultsCtrl($scope, $location, JobSearchSvc) {

        if ($scope.userHasRight('CANDHIDEJOBSPAGE')) {
            $location.url('/noPermission')
        return
        }
    
        if (!JobSearchSvc.searchFields) {
            $location.url('/jobsearch/advanced')  // We've arrived here with no search criteria
            return
        }
        
        $scope.currentPage=1
        $scope.totalItems=1000000 // May be adjusted downwards when we know how many there are
        $scope.itemsPerPage=10
        
        $scope.fetch=function(){
            JobSearchSvc.currentPage=$scope.currentPage  // Remember page for back navigation
            var start=($scope.currentPage-1)*$scope.itemsPerPage
            $scope.pageOfJobs=$scope.rawJobs.slice(start,start+$scope.itemsPerPage)
            $scope.sliceCaption='Jobs ' + (start+1).toString()+' to ' + Math.min(start+$scope.itemsPerPage, $scope.rawJobs.length).toString() + ' out of ' + $scope.rawJobs.length.toString()
        }
        
        $scope.searchAgain=function(){
            $location.url('/jobsearch/advanced')  // Go back to the search
        }
        
        $scope.expandJob=function(job){
            $location.url('/jobsearch/results/'+job.vacancyid) 
        }
      
        // If string chops off the characters after the first 50 then addeds '...' if longer
        // If ISO date formats as UK
        $scope.jFmt=function(val){
        if (val==undefined || typeof val==='number'){
          return val
        }
        var ln=val.length
        if (ln==10) {
          var ar=val.match(/^(\d{4}).(\d{2}).(\d{2})/)
          if (ar){  // iso date - format as dd/mm/yyyy
            return ar[3]+'/'+ar[2]+'/'+ar[1]
          }
        }
        return val.substr(0,50)+ ((ln>50)?'...':'')
        }
        
        $scope.showDistance=function(){
          return (JobSearchSvc.GeoLocation.allowed && JobSearchSvc.GeoLocation.data)
        }
      
        $scope.fetchJobs = function() {   // Show list of jobs - the search result
        JobSearchSvc.getSearchFields()
        .then(function(){return JobSearchSvc.findJobs()})
            .then(function(){
                $scope.rawJobs=JobSearchSvc.rawJobs
                $scope.rawFields=JobSearchSvc.rawFields
                $scope.currentPage=JobSearchSvc.currentPage || 1
                $scope.totalItems=$scope.rawJobs.length
                $scope.fetch()
            })
        }
    
        $scope.fetchJobs()  // List of jobs
    }

})()